import Lottie from "lottie-react";
import "./Loading.css";
import React from "react";
import animationLoading from "../../assets/images/animationLoading.json";
export default function Loading() {
  return (
    <div className="loading-container">
      <Lottie
        animationData={animationLoading}
        loop={true}
        style={{ width: 200, height: 200, position: "relative", zIndex: 2 }}
      />
      <h4 className="loading-text">لطفا صبور باشید ...</h4>
    </div>
  );
}
